import { Pipe, PipeTransform } from '@angular/core';
import { WeekIndex } from '../types/menu';
import { getCurrentWeekNumber } from '../utils/date.utils';

@Pipe({
  name: 'weekIndexByWeekNumber',
})
export class WeekIndexByWeekNumberPipe implements PipeTransform {
  transform(weekNumber: number | null): WeekIndex | null {
    if (weekNumber === null) {
      return null;
    }
    const currentWeekNumber = getCurrentWeekNumber();
    if (currentWeekNumber === weekNumber) {
      return WeekIndex.THIS_WEEK;
    }
    if (currentWeekNumber + 1 === weekNumber) {
      return WeekIndex.NEXT_WEEK;
    }
    return null;
  }
}
